/* TuffBase PDP behaviours: gallery, accordions, tabs, sticky Buy Now bar,
   and GA4 `select_retailer` (pushed to the existing GTM dataLayer only —
   GTM-53F4CK2 is in theme.liquid, so no direct gtag call, to avoid duplicates). */
(function () {
  'use strict';

  function ready(fn) { document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', fn) : fn(); }

  function initGallery(root) {
    var stage = root.querySelector('[data-tbp-stage]');
    if (!stage) return;
    var imgs = [].slice.call(stage.querySelectorAll('.tbp-gallery__img'));
    var thumbs = [].slice.call(root.querySelectorAll('.tbp-gallery__thumb'));
    var count = stage.querySelector('[data-tbp-count]');
    var idx = 0, n = imgs.length;
    function show(i) {
      idx = (i + n) % n;
      imgs.forEach(function (im, k) {
        var on = k === idx;
        im.classList.toggle('is-active', on);
        im.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) im.loading = 'eager';
      });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-selected', k === idx ? 'true' : 'false'); t.tabIndex = k === idx ? 0 : -1; });
      if (count) count.textContent = (idx + 1) + ' / ' + n;
    }
    var prev = root.querySelector('[data-tbp-prev]'), next = root.querySelector('[data-tbp-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { show(k); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { show(idx + 1); thumbs[idx].focus(); e.preventDefault(); }
        if (e.key === 'ArrowLeft') { show(idx - 1); thumbs[idx].focus(); e.preventDefault(); }
      });
    });
    var tx = 0;
    stage.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - tx;
      if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);
    }, { passive: true });
    var zoom = root.querySelector('[data-tbp-zoom]');
    if (zoom) zoom.addEventListener('click', function () { openLightbox(imgs, idx); });
    show(0);
  }

  // Full-size zoom: thin adapter over the theme's bundled PhotoSwipe v4 (snippets/photoswipe-template.liquid,
  // loaded globally in theme.liquid) — same approach as the TuffBlock PDP — plus zoom in/out buttons and wheel zoom.
  function openLightbox(images, start) {
    var el = document.querySelectorAll('.pswp')[0];
    if (!el || typeof PhotoSwipe === 'undefined' || typeof PhotoSwipeUI_Default === 'undefined') return;
    var items = images.map(function (img) {
      return { src: img.getAttribute('data-tbp-full') || img.currentSrc || img.src,
               w: parseInt(img.getAttribute('data-tbp-full-w'), 10) || 0, h: parseInt(img.getAttribute('data-tbp-full-h'), 10) || 0,
               msrc: img.currentSrc || img.src };
    });
    var pswp = new PhotoSwipe(el, PhotoSwipeUI_Default, items, {
      index: start || 0, history: false, captionEl: false, counterEl: false, preloaderEl: false, shareEl: false,
      closeOnScroll: false, bgOpacity: 0.9,
      getThumbBoundsFn: function (i) {
        var r = images[i].getBoundingClientRect();
        return { x: r.left, y: r.top + (window.pageYOffset || document.documentElement.scrollTop), w: r.width };
      }
    });
    var ui = el.querySelector('.pswp__ui');
    var controls = null;
    if (ui) {
      controls = document.createElement('div');
      controls.className = 'pl-pswp-zoom-controls';
      controls.innerHTML =
        '<button type="button" class="pl-pswp-zoom-btn" data-out aria-label="Zoom out"><svg aria-hidden="true" focusable="false" viewBox="0 0 20 20"><path fill="currentColor" d="M17.543 11.029H2.1A1.032 1.032 0 0 1 1.071 10c0-.566.463-1.029 1.029-1.029h15.443c.566 0 1.029.463 1.029 1.029 0 .566-.463 1.029-1.029 1.029z"/></svg></button>' +
        '<button type="button" class="pl-pswp-zoom-btn" data-in aria-label="Zoom in"><svg aria-hidden="true" focusable="false" viewBox="0 0 20 20"><path fill="currentColor" d="M17.409 8.929h-6.695V2.258c0-.566-.506-1.029-1.071-1.029s-1.071.463-1.071 1.029v6.671H1.967C1.401 8.929.938 9.435.938 10s.463 1.071 1.029 1.071h6.605V17.7c0 .566.506 1.029 1.071 1.029s1.071-.463 1.071-1.029v-6.629h6.695c.566 0 1.029-.506 1.029-1.071s-.463-1.071-1.029-1.071z"/></svg></button>';
      ui.appendChild(controls);
    }
    function zoomBy(f) {
      if (!pswp.currItem) return;
      var min = pswp.currItem.initialZoomLevel, max = Math.max(min * 4, 1);
      var level = Math.min(Math.max(pswp.getZoomLevel() * f, min), max);
      pswp.zoomTo(level, { x: pswp.viewportSize.x / 2, y: pswp.viewportSize.y / 2 }, 200);
    }
    if (controls) {
      controls.querySelector('[data-in]').addEventListener('click', function () { zoomBy(1.5); });
      controls.querySelector('[data-out]').addEventListener('click', function () { zoomBy(1 / 1.5); });
    }
    function onWheel(e) { if (!pswp.currItem) return; e.preventDefault(); zoomBy(e.deltaY < 0 ? 1.15 : 1 / 1.15); }
    el.addEventListener('wheel', onWheel, { passive: false });
    pswp.listen('close', function () { el.removeEventListener('wheel', onWheel); if (controls) controls.remove(); });
    pswp.init();
  }

  function initAccordions(root) {
    root.querySelectorAll('[data-tbp-acc]').forEach(function (item) {
      var btn = item.querySelector('button'), panel = item.querySelector('[data-tbp-panel]');
      if (!btn || !panel) return;
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.hidden = open;
        item.classList.toggle('is-open', !open);
      });
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-tbp-tabs]').forEach(function (wrap) {
      var tabs = [].slice.call(wrap.querySelectorAll('[role="tab"]'));
      var panels = [].slice.call(wrap.querySelectorAll('[role="tabpanel"]'));
      function select(i, focus) {
        tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
        panels.forEach(function (p, k) { p.hidden = k !== i; });
        if (focus) tabs[i].focus();
      }
      tabs.forEach(function (t, k) {
        t.addEventListener('click', function () { select(k); });
        t.addEventListener('keydown', function (e) {
          var j = null;
          if (e.key === 'ArrowRight') j = (k + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') j = (k - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') j = 0;
          else if (e.key === 'End') j = tabs.length - 1;
          if (j !== null) { select(j, true); e.preventDefault(); }
        });
      });
      // "View full specifications" link in the hero accordion
      document.querySelectorAll('[data-tbp-goto-tab]').forEach(function (a) {
        a.addEventListener('click', function (e) {
          var k = parseInt(a.getAttribute('data-tbp-goto-tab'), 10);
          select(k);
          var target = document.getElementById('tb-details');
          if (target) { target.scrollIntoView({ behavior: 'smooth', block: 'start' }); e.preventDefault(); }
        });
      });
      select(0);
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-tbp-sticky]');
    var anchor = document.querySelector('[data-tbp-hero-cta]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    var link = bar.querySelector('[data-tbp-sticky-link]');
    function setOffset() {
      // If the theme header is stuck/fixed to the top, sit directly beneath it instead of over it.
      var h = document.querySelector('.header-wrapper');
      var top = 0;
      if (h) {
        var pos = getComputedStyle(h).position;
        if (pos === 'fixed' || pos === 'sticky') top = Math.max(0, h.getBoundingClientRect().bottom);
      }
      bar.style.setProperty('--tbp-bar-top', top + 'px');
    }
    var io = new IntersectionObserver(function (entries) {
      var en = entries[0];
      var stuck = !en.isIntersecting && en.boundingClientRect.top < 0;
      setOffset();
      bar.classList.toggle('is-on', stuck);
      bar.setAttribute('aria-hidden', stuck ? 'false' : 'true');
      if (link) link.tabIndex = stuck ? 0 : -1;
    });
    io.observe(anchor);
    window.addEventListener('resize', setOffset);
  }

  function buildEmbed(url) {
    var yt = url.match(/(?:youtu\.be\/|youtube\.com\/watch\?v=|youtube\.com\/embed\/)([\w-]+)/);
    var vimeo = url.match(/vimeo\.com\/(\d+)/);
    if (yt) return '<iframe src="https://www.youtube.com/embed/' + yt[1] + '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
    if (vimeo) return '<iframe src="https://player.vimeo.com/video/' + vimeo[1] + '?autoplay=1" allow="autoplay; fullscreen" allowfullscreen></iframe>';
    return '<video src="' + url + '" controls autoplay playsinline></video>';
  }

  function initVideo() {
    document.querySelectorAll('[data-tbp-video]').forEach(function (frame) {
      var modal = document.getElementById(frame.getAttribute('data-tbp-video-modal'));
      if (!modal) return;
      var holder = modal.querySelector('[data-tbp-video-media]');
      function close() {
        modal.classList.remove('is-open'); modal.hidden = true;
        holder.innerHTML = ''; // stops playback
        frame.focus();
      }
      frame.addEventListener('click', function () {
        holder.innerHTML = buildEmbed(frame.getAttribute('data-tbp-video'));
        modal.hidden = false; modal.classList.add('is-open');
        modal.querySelector('[data-tbp-video-close]').focus();
      });
      modal.querySelector('[data-tbp-video-close]').addEventListener('click', close);
      modal.addEventListener('click', function (e) { if (e.target === modal) close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && modal.classList.contains('is-open')) close(); });
    });
  }

  function initTracking() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-ga-event="select_retailer"]');
      if (!a) return;
      var placement = a.getAttribute('data-ga-placement');
      if (placement === 'sticky') placement = window.innerWidth < 768 ? 'mobile_sticky' : 'desktop_sticky';
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'select_retailer',
        retailer: a.getAttribute('data-ga-retailer') || 'bunnings',
        product: a.getAttribute('data-ga-product') || 'tuffbase',
        placement: placement,
        link_url: a.href
      });
      // Navigation is left to the browser (plain <a target="_blank">), so tracking can never block it.
    });
  }

  ready(function () {
    var root = document;
    initGallery(root); initAccordions(root); initTabs(root); initSticky(); initVideo(); initTracking();
  });
})();
